import { useQuery, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { useAuth } from '../../../hooks/useAuth'

export const usePantry = () => {
  const { household, user } = useAuth()
  const qc  = useQueryClient()
  const key = ['pantry', household?.id]

  const query = useQuery({
    queryKey: key,
    enabled:  !!household?.id,
    queryFn:  async () => {
      const { data, error } = await supabase
        .from('pantry_items')
        .select('id, name, quantity, unit, location, expiry_date, min_quantity, created_by')
        .eq('household_id', household.id)
        .order('name')
      if (error) throw error
      return data ?? []
    },
  })

  const inv = () => qc.invalidateQueries({ queryKey: key })

  const addItem = async (fields) => {
    const { error } = await supabase
      .from('pantry_items')
      .insert({ ...fields, household_id: household.id, created_by: user.id })
    if (error) throw error
    inv()
  }

  const updateItem = async ({ id, ...fields }) => {
    const { error } = await supabase.from('pantry_items').update(fields).eq('id', id)
    if (error) throw error
    inv()
  }

  const deleteItem = async (id) => {
    const { error } = await supabase.from('pantry_items').delete().eq('id', id)
    if (error) throw error
    inv()
  }

  return { ...query, addItem, updateItem, deleteItem }
}
